import React from 'react'
import { FlatList, SectionList, View } from 'react-native'
import { IEvent } from 'matrix-js-sdk'

import { useMessages } from '../queries'
import { useCommunitiesTheme } from '../themes'

import ChatBubble from './ChatBubble/ChatBubble'
import DayBanner from './DayBanner'

type OrderedData = {
  date: string
  data: IEvent[]
}

type MessageListProps = {
  roomId: string
  spaceId: string
  isFiltered?: boolean
  memberId?: string
  filter: string
}

type Accumulator = {
  [key: string]: { data: IEvent[]; date: string; key: number }
}

const MessageList = ({
  roomId,
  isFiltered,
  memberId,
  filter: activeFilter,
  spaceId
}: MessageListProps) => {
  const { data: queryMessages } = useMessages(roomId, activeFilter, true)

  const queryMessagesMapped = queryMessages?.pages.flatMap(group => {
    return group?.map((event: IEvent) => event)
  })

  const filteredData = memberId
    ? queryMessagesMapped?.filter(msg => msg.sender === memberId) ?? []
    : queryMessagesMapped ?? []

  let res: OrderedData[] = []
  if (filteredData.length > 0) {
    filteredData.sort((a, b) => b.origin_server_ts - a.origin_server_ts)

    res = Object.values(
      filteredData.reduce((acc: Accumulator, curr) => {
        const dateFormat = new Date(curr.origin_server_ts)
        const date = dateFormat.toDateString()
        acc[date] ??= { date, data: [], key: curr.origin_server_ts }
        acc[date].data.push(curr)
        return acc
      }, {})
    )
  }

  const renderItem = ({ item }: { item: IEvent }) =>
    item ? <ChatBubble matrixMessage={item} spaceId={spaceId} isThread={false} /> : null

  const communitiesTheme = useCommunitiesTheme()

  const renderItemSeparatorComponent = (index: number) => (
    <View
      key={index}
      style={{ width: '100%', height: 1, backgroundColor: communitiesTheme.messageList.border }}
    />
  )

  if (isFiltered) {
    return (
      <FlatList
        data={filteredData}
        keyExtractor={(item, index) => `wrapper-${item.event_id}-${index}`}
        renderItem={renderItem}
        ItemSeparatorComponent={renderItemSeparatorComponent}
        maxToRenderPerBatch={5}
        initialNumToRender={5}
      />
    )
  }

  return (
    <SectionList
      // TODO: use this to refresh data
      // onEndReached={}
      // onEndReachedThreshold={0.5}
      sections={res}
      renderItem={renderItem}
      renderSectionHeader={({ section: { date } }) => <DayBanner date={date} />}
      ItemSeparatorComponent={renderItemSeparatorComponent}
      maxToRenderPerBatch={5}
      initialNumToRender={5}
    />
  )
}

export default MessageList
